export default __webpack_public_path__ + "static/media/623.a4b14ee4.png";